/* unplugin-vue-components disabled */import script from "./DownloadAndShareInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./DownloadAndShareInfo.vue?vue&type=script&lang=ts&setup=true"

import "./DownloadAndShareInfo.vue?vue&type=style&index=0&id=299395f4&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-299395f4"]])

export default __exports__